 
 
 
import TextField from "@material-ui/core/TextField";
 

const index = ({InputProps,additionClass,loading=false,label,htmlFor,tName,type,endAdornment,handleChange,value,additionLabelClass,error,placeholder,multiline}) => {
    return (
        <div className={"input  "+additionClass}  >
                <label className={"fieldLabel EMPHASIS_SMALL "+additionLabelClass} htmlFor={htmlFor}>{label}</label>
                <TextField
                    type={type}
                    disabled={loading}
                    className={"input"}
                    placeholder={placeholder}
                    id={htmlFor}
                    inputProps={InputProps}
                    name={tName}
                    multiline={multiline}
                    value={value}
                    error={error}
                    variant="outlined"
                    onChange={handleChange}
                    endAdornment={endAdornment}
                   
                />
         </div>
    );
  }
  
  export default index;
  